import React from "react";

const MergeButton: React.FC<{ onClick: () => void; showUnmerge: boolean }> = ({ onClick, showUnmerge }) => (
	<div onClick={onClick} className="relative w-[40px] h-[40px] btn">
		{showUnmerge ? (
			<img className="absolute w-[36px] h-[36px]" src="/assets/ui/unmerge.svg" />
		) : (
			<>
				<img className="absolute -left-2 top-1 w-[40px] h-[40px]" src="/assets/ui/merge-bg.svg" />
				<img className="absolute w-[36px] h-[36px]" src="/assets/ui/merge-front.svg" />
			</>
		)}
	</div>
);

export default MergeButton;
